import { ItemInterface, ReactSortable } from "react-sortablejs";

import _ from "lodash";
import styled from "styled-components";

import Dropzone from "components/ui-kit/dropzone";
import { Frame, PhotoDropzone, Row, TPhotoDropzoneProps } from "components/ui-kit/styled-templates";

import { downloadURI } from "services/common-service";

const GalleryInput = (props: { value: string[]; onChange: Function; dropzoneProps?: TPhotoDropzoneProps; maxFilesNumber?: number }) => {
    const { value: valueFromProps, onChange = () => {}, maxFilesNumber = Infinity } = props;

    const value = _.isArray(valueFromProps) ? valueFromProps : !_.isEmpty(valueFromProps) ? [valueFromProps] : [];

    return (
        <>
            {value?.length < maxFilesNumber && (
                <Dropzone
                    accept="image/jpeg, image/png"
                    extra={`width: inherit;`}
                    {..._.omit(props, [`value`, `onChange`, `dropzoneProps`])}
                    onChange={(e: any) => {
                        onChange({ target: { value: [...(value ?? []), e.target.value] } });
                    }}
                >
                    <PhotoDropzone {...props.dropzoneProps} />
                </Dropzone>
            )}
            <Row
                extra={`> * { width: 100%; display: flex; flex-directoin: row; gap: 15px; flex-wrap: wrap; justify-content: flex-start; margin-top: 15px; };`}
            >
                <ReactSortable
                    list={value as any}
                    setList={(newValue: ItemInterface[]) => {
                        if (newValue.filter((i) => typeof i !== `string`).length === 0) {
                            onChange({ target: { value: newValue } });
                        }
                    }}
                >
                    {value?.map?.((item: string, index) => {
                        const type =
                            {
                                jpeg: "image/jpeg",
                                png: "image/png",
                                pdf: "application/pdf",
                                doc: "application/msword",
                                docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                mp4: "video/mp4",
                                mov: "video/quicktime",
                            }?.[item?.split?.(".")?.at?.(-1) ?? `jpeg`]?.split?.(`/`)?.[0] ?? `image`;
                        const imgSrc =
                            {
                                image: item,
                                video: require(`assets/icons/dropzone-video.svg`).default,
                                application: require(`assets/icons/dropzone-file.svg`).default,
                            }?.[type] ?? item;
                        return (
                            <Frame key={index} extra={`align-items: flex-start; gap: 5px;`}>
                                <UploadedItem onClick={(e: any) => !e.target.className?.includes?.(`delete-file-cors`) && downloadURI(item, item)}>
                                    <img src={imgSrc} alt="" />
                                    <Cros
                                        className="delete-file-cors"
                                        onClick={() => onChange({ target: { value: value.filter((_, j) => j !== index) } })}
                                    />
                                </UploadedItem>
                                <FileName>{item?.split?.(`/`)?.at?.(-1)}</FileName>
                            </Frame>
                        );
                    })}
                </ReactSortable>
            </Row>
        </>
    );
};

const FileName = styled(Frame)`
    text-overflow: ellipsis;
    max-width: 110px;
    overflow: hidden;
    display: block;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    color: ${({ theme }) => theme.text.secondary};
`;

const Cros = styled.img.attrs((props: any) => {
    return {
        ...props,
        src: require(`assets/icons/photo-cros.svg`).default,
    };
})`
    width: 20px;
    height: 20px;
    position: absolute;
    top: 6px;
    right: 6px;
    cursor: pointer;

    &:hover {
        transform: rotate(90deg);
    }
`;

const UploadedItem = styled(Frame)`
    width: 150px;
    height: 150px;
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    cursor: pointer;

    background: rgba(201, 212, 219, 0.1);
    border: 1px solid rgba(201, 212, 219, 0.5);
    box-sizing: border-box;

    &:hover {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    }

    > * {
        &:first-child {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
`;

export default GalleryInput;
